import { render, staticRenderFns } from "./WorklistDelete.vue?vue&type=template&id=54b39677"
import script from "./WorklistDelete.vue?vue&type=script&lang=js"
export * from "./WorklistDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports